import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import { ISOTService } from '../../services';

export interface AgeDialogConfig {
  sot_service: ISOTService;
  requiredAge: number;
}

@Component({
  selector: "sot-agedialog",
  templateUrl: "./agedialog.component.html",
  styleUrls: ["./agedialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AgeDialogComponent implements OnInit, OnDestroy {

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<AgeDialogComponent, string>
    , @Inject(MAT_DIALOG_DATA) public agedialogConfig: AgeDialogConfig
    , private _coreLogService: CoreLogService) {
  }

  public ngOnInit(): void {
    console.debug("--- sot-agedialog ngOnInit")
    this.PushChanges();
  }

  public get isModeOne(): boolean {
    return this.agedialogConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.agedialogConfig.sot_service.Accessabilty.useModeTwo;
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-agedialog ngOnDestroy")
  }

  public confirm(): void {
    const me = this;
    me.dialogRef.close("yes");
  }

  public cancel(): void {
    const me = this;
    me.dialogRef.close("no");
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("AgeDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}